import { IFeedReportInitialState } from '../interfaces/FeedReportInterface';

export const FEED_REPORT_INITIAL_STATE: IFeedReportInitialState = {
    sevenDayFeedReport: [],
    manualFeedSheetReport: [],
    averageAsFedReport: [],
    scheduleRationChangeReport: [],
};
